import { Star } from 'lucide-react'
import { useMemo } from 'react'

import { cn } from '~/DesignSystem/lib/utils'

type RateInputProps = Pick<React.ComponentProps<'input'>, 'value' | 'min' | 'max' | 'className'> & {
  onChange?: (value?: number) => void
}

const RateInput = ({ value: inValue, onChange, min = 1, max = 5, className }: RateInputProps) => {
  const value = Number(inValue)
  const range = useMemo<number[]>(() => {
    return Array.from({ length: Number(max) - Number(min) + 1 }, (_, i) => Number(min) + i)
  }, [min, max])

  return (
    <div className={cn('inline-flex gap-6', className)}>
      {range.map(index => (
        <button key={index} type="button" onClick={() => onChange?.(index)}>
          <Star
            className={cn({
              'fill-yellow-400 stroke-yellow-400': index <= value,
            })}
          />
        </button>
      ))}
    </div>
  )
}

export default RateInput
